module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/stavyToku@2x-a945afa5979cd3c3d6ce7f4e41fad826.png";